import { apiGet } from './client.js';

export type ImeiLookupResult = {
  imei: string;
  valid: boolean;
  deviceInfo: {
    make: string;
    model: string;
    modelNumber: string;
    storage: string;
    color: string;
    carrier: string;
    releaseYear: string;
  } | null;
  blacklistStatus: {
    status: 'clean' | 'lost' | 'stolen' | 'blocked' | 'unknown';
    reportedDate: string | null;
    carrier: string | null;
  } | null;
  warrantyInfo: {
    status: string;
    expiresAt: string | null;
  } | null;
  error?: string;
};

export function lookupImei(imei: string): Promise<ImeiLookupResult> {
  return apiGet<ImeiLookupResult>(`/api/v1/devices/imei/${imei}`).then((r) => r.data);
}
